<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Login",
  setup() {
    return {};
  },
});
</script>

<template>
  <h2>Please Login to continue</h2>
</template>
